import $ from 'jquery';

export default function() {
    $('.bkg-img').each(function() {
        var img = $('img:first', this);
        var theImage = img.attr('src');
        $(this).css('background-image', 'url("' + theImage + '")');
        img.hide();
    })
}


// WEBPACK FOOTER //
// ./src/js/partials/bkg-image.js